import React from 'react';
import { Form, RadioGroup, RadioItem } from 'src/components/Antd';
import css from './css.module.less';
import { get } from 'lodash';
import { Select } from 'src/components/Antd/Select';
import { generalFilterOptions } from 'src/tools/helper';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { Icon } from '@/src/tools/icon';

const Item = Form.Item;
const Option = Select.Option;
export enum EInclude {
  any = 'INCLUDE_ANY_SELECTED',
  all = 'INCLUDE_ALL_SELECTED',
  EXCLUDE_ALL_SELECTED = 'EXCLUDE_ALL_SELECTED',
  EXCLUDE_ANY_SELECTED = 'EXCLUDE_ANY_SELECTED',
}
const CommonRadioMulSelect = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    radioOptions,
    selectOptions,
    radioName,
    selectName,
    triggerName = [
      EInclude.any,
      EInclude.all,
      EInclude.EXCLUDE_ALL_SELECTED,
      EInclude.EXCLUDE_ANY_SELECTED,
    ],
    noStyle,
    selectPlaceholder,
    hasExclude,
    disabled,
    generateOptions,
  } = props;

  const _radio =
    radioOptions ||
    (!!hasExclude
      ? [
          {
            label: getI18n(
              'general.advancedFilters.commonRadioMulSelect.includeAnySelect',
            ),
            value: EInclude.any,
          },
          {
            label: getI18n(
              'general.advancedFilters.commonRadioMulSelect.includeAllSelect',
            ),
            value: EInclude.all,
          },
          {
            label: getI18n(
              'general.advancedFilters.commonRadioMulSelect.excludeAnySelect',
            ),
            value: EInclude.EXCLUDE_ANY_SELECTED,
          },
          {
            label: getI18n(
              'general.advancedFilters.commonRadioMulSelect.excludeAllSelect',
            ),
            value: EInclude.EXCLUDE_ALL_SELECTED,
          },
        ]
      : [
          {
            label: getI18n(
              'general.advancedFilters.commonRadioMulSelect.includeAnySelect',
            ),
            value: EInclude.any,
          },
          {
            label: getI18n(
              'general.advancedFilters.commonRadioMulSelect.includeAllSelect',
            ),
            value: EInclude.all,
          },
        ]);

  return (
    <React.Fragment>
      <Item name={radioName} noStyle={noStyle}>
        <RadioGroup className={css.groupContainer} disabled={disabled}>
          {_radio.map((i) => {
            return (
              <RadioItem className={css.item} value={i.value} key={i.value}>
                {i.label}
              </RadioItem>
            );
          })}
        </RadioGroup>
      </Item>
      <Item
        noStyle
        shouldUpdate={(p, c) => {
          const cT = get(c, radioName);
          const pT = get(p, radioName);
          return cT !== pT;
        }}>
        {(f) => {
          const { getFieldValue } = f;
          const include = getFieldValue(radioName);
          if (triggerName.includes(include)) {
            return (
              <Item
                name={selectName}
                noStyle={noStyle}
                rules={[
                  {
                    required: true,
                    message: getI18n(
                      'general.advancedFilters.commonRadioMulSelect.selectItem',
                    ),
                  },
                ]}>
                <Select
                  suffixIcon={<Icon type='iconsearch' />}
                  disabled={disabled}
                  showArrow
                  //getPopupContainer={() => document.body}
                  selectClassName={css.select}
                  size='large'
                  placeholder={selectPlaceholder}
                  filterOption={generalFilterOptions}
                  showSearch
                  mode='multiple'>
                  {generateOptions
                    ? generateOptions(selectOptions)
                    : (selectOptions || []).map((i) => {
                        const { label, value } = i;
                        return (
                          <Option value={value} key={value}>
                            {label}
                          </Option>
                        );
                      })}
                </Select>
              </Item>
            );
          }
        }}
      </Item>
    </React.Fragment>
  );
};
export default CommonRadioMulSelect;
